
<div class="px-3 " style="position: absolute; bottom: 15px; float: left;width:75%">
    <div class="imagesliderpadding">
        <ng-image-slider style="cursor: pointer;"  *ngIf="imageObject.length>0" #nav [images]="imageObject" [imagePopup]="false"
            [infinite]="imageObject.length>1 ? true : false" [autoSlide]="1" [imageSize]="{width: 195, height: 50,space:4}"
            [showArrow]="false" [animationSpeed]="4" slideImage="1"
            (imageClick)="imageClickHandler($event,imageObject[$event])"></ng-image-slider>
    </div>
    
</div>
<div class="px-3" style="position: absolute; bottom: 15px; right: 0;width:25%">
    <img src="../../assets/apportis-new-logo.png" alt="logo-dark" style="max-width:180px;max-height:50px; float: right;">
</div>